import { ref } from 'vue'
import { useLoading } from '@/composables/useLoading'

export default function ReviewAdminController () {
  const { loading, loadingOn, loadingOff } = useLoading()

  const reviews = ref([])
  const mess = ref(null)
  const messVisible = ref(false)

  // Получить все отзывы
  const getReviews = async () => {
    loadingOn()
    try {
      const response = await fetch('https://valeriya-artist-admin.ru/api/reviews', {
        method: 'GET',
        headers: {
          Authorization: localStorage.getItem('admin_token')
        }
      })
      if (response.ok) {
        const res = await response.json()
        reviews.value = res
      } else {
        const res = await response.json()
        mess.value = res?.err || 'Ошибка при загрузке отзывов'
        messVisible.value = true
        setTimeout(() => (messVisible.value = false), 3000)
      }
    } catch (error) {
      mess.value = 'Ошибка при загрузке отзывов'
      messVisible.value = true
      setTimeout(() => (messVisible.value = false), 3000)
    } finally {
      loadingOff()
    }
  }

  // Обновить статус отзыва
  const updateReviewStatus = async (reviewId, isPublic) => {
    loadingOn()
    try {
      const response = await fetch('https://valeriya-artist-admin.ru/api/reviews/update', {
        method: 'POST',
        headers: {
          Authorization: localStorage.getItem('admin_token')
        },
        body: JSON.stringify({
          review_id: reviewId,
          is_public: isPublic
        })
      })

      const res = await response.json()

      if (response.ok) {
        mess.value = res?.mess || 'Статус отзыва обновлен'
        messVisible.value = true
        await getReviews()
        setTimeout(() => (messVisible.value = false), 3000)
      } else {
        mess.value = res?.err || 'Ошибка при обновлении статуса'
        messVisible.value = true
        setTimeout(() => (messVisible.value = false), 3000)
      }
    } catch (error) {
      mess.value = 'Ошибка при обновлении статуса'
      messVisible.value = true
      setTimeout(() => (messVisible.value = false), 3000)
    } finally {
      loadingOff()
    }
  }

  // Удалить отзыв (через API основного сайта, чтобы удалить фото)
  const deleteReview = async (reviewId) => {
    loadingOn()
    try {
      const response = await fetch('https://valeriya-artist.art/api/reviews/delete', {
        method: 'POST',
        headers: {
          Authorization: localStorage.getItem('admin_token')
        },
        body: JSON.stringify({
          review_id: reviewId
        })
      })

      const res = await response.json()

      if (response.ok) {
        mess.value = res?.mess || 'Отзыв удален'
        messVisible.value = true
        await getReviews()
        setTimeout(() => (messVisible.value = false), 3000)
      } else {
        mess.value = res?.err || 'Ошибка при удалении отзыва'
        messVisible.value = true
        setTimeout(() => (messVisible.value = false), 3000)
      }
    } catch (error) {
      mess.value = 'Ошибка при удалении отзыва'
      messVisible.value = true
      setTimeout(() => (messVisible.value = false), 3000)
    } finally {
      loadingOff()
    }
  }

  // Массовое обновление статусов
  const bulkUpdateStatus = async (reviewIds, isPublic) => {
    loadingOn()
    try {
      const promises = reviewIds.map(id =>
        fetch('https://valeriya-artist-admin.ru/api/reviews/update', {
          method: 'POST',
          headers: {
            Authorization: localStorage.getItem('admin_token')
          },
          body: JSON.stringify({
            review_id: id,
            is_public: isPublic
          })
        })
      )

      const responses = await Promise.all(promises)
      const allOk = responses.every(r => r.ok)

      if (allOk) {
        mess.value = `Статусы ${reviewIds.length} отзывов обновлены`
        messVisible.value = true
        await getReviews()
        setTimeout(() => (messVisible.value = false), 3000)
      } else {
        mess.value = 'Ошибка при массовом обновлении статусов'
        messVisible.value = true
        setTimeout(() => (messVisible.value = false), 3000)
      }
    } catch (error) {
      mess.value = 'Ошибка при массовом обновлении статусов'
      messVisible.value = true
      setTimeout(() => (messVisible.value = false), 3000)
    } finally {
      loadingOff()
    }
  }

  // Массовое удаление отзывов (через API основного сайта)
  const bulkDelete = async (reviewIds) => {
    loadingOn()
    try {
      const promises = reviewIds.map(id =>
        fetch('https://valeriya-artist.art/api/reviews/delete', {
          method: 'POST',
          headers: {
            Authorization: localStorage.getItem('admin_token')
          },
          body: JSON.stringify({
            review_id: id
          })
        })
      )

      const responses = await Promise.all(promises)
      const allOk = responses.every(r => r.ok)

      if (allOk) {
        mess.value = `${reviewIds.length} отзывов удалено`
        messVisible.value = true
        await getReviews()
        setTimeout(() => (messVisible.value = false), 3000)
      } else {
        mess.value = 'Ошибка при массовом удалении'
        messVisible.value = true
        setTimeout(() => (messVisible.value = false), 3000)
      }
    } catch (error) {
      mess.value = 'Ошибка при массовом удалении'
      messVisible.value = true
      setTimeout(() => (messVisible.value = false), 3000)
    } finally {
      loadingOff()
    }
  }

  const changeSortReviews = async (firstId, secondId, firstSort, secondSort) => {
    loadingOn()
    try {
      const response = await fetch('https://valeriya-artist-admin.ru/api/reviews/sort', {
        method: 'POST',
        headers: {
          Authorization: localStorage.getItem('admin_token')
        },
        body: JSON.stringify({
          firstId: firstId,
          secondId: secondId,
          firstSort: firstSort,
          secondSort: secondSort
        })
      })

      const res = await response.json()

      if (response.ok) {
        mess.value = res?.mess || 'Сортировка обновлена'
        messVisible.value = true
        await getReviews()
        setTimeout(() => (messVisible.value = false), 3000)
      } else {
        mess.value = res?.err || 'Ошибка при изменении сортировки'
        messVisible.value = true
        setTimeout(() => (messVisible.value = false), 3000)
      }
    } catch (error) {
      mess.value = 'Ошибка при изменении сортировки'
      messVisible.value = true
      setTimeout(() => (messVisible.value = false), 3000)
    } finally {
      loadingOff()
    }
  }

  // Очистить сообщение
  const clearMess = () => {
    mess.value = null
    messVisible.value = false
  }

  return {
    loading,
    reviews,
    mess,
    messVisible,
    getReviews,
    updateReviewStatus,
    deleteReview,
    bulkUpdateStatus,
    bulkDelete,
    changeSortReviews,
    clearMess
  }
}
